module.exports = __webpack_public_path__ + "static/media/footer-logo-icon.ad572bd1.svg";